import React from "react";

import "./test.styles.scss";

const Test = () => {
    return (
        <div>
            <h1>sad</h1>
            <body>
                <div class="circle">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="big">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="tri"></div>
                <div class="squ">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="end">
                    <div>E</div>
                    <div>N</div>
                    <div>D</div>
                </div>
            </body>
        </div>
    );
};

export default Test;
